import { existsSync, mkdirSync, readFileSync, writeFileSync } from 'fs';
import { join } from 'path';
import { parseYaml, stringifyYaml } from './yaml.js';
import { REPO_CONFIG_FILE, type Workspace } from './workspace.js';

/**
 * `rekor-ws/rekor.yaml` — repo-level defaults. `default_database` lets a bare `rekor pull`/`push`
 * resolve a target. (Org binding lives in the repo-root `.rekor.yaml` — see `root-config.ts`. A
 * legacy `org_id` key here is tolerated but ignored.)
 */
export interface RepoConfig {
  default_database?: string;
}

function repoConfigPath(ws: Workspace): string {
  return join(ws.wsDir, REPO_CONFIG_FILE);
}

export function readRepoConfig(ws: Workspace): RepoConfig | null {
  const path = repoConfigPath(ws);
  if (!existsSync(path)) return null;
  try {
    return (parseYaml(readFileSync(path, 'utf-8')) as RepoConfig | null) ?? {};
  } catch {
    return null;
  }
}

export function writeRepoConfig(ws: Workspace, config: RepoConfig): string {
  mkdirSync(ws.wsDir, { recursive: true });
  const path = repoConfigPath(ws);
  writeFileSync(path, stringifyYaml(config));
  return path;
}
